<div *ngIf="isLoading" class="pt-4 ps-4">
  <mat-spinner class="m-0 m-auto"></mat-spinner>
</div>
<div *ngIf="serverResponse" class="row">
  <div class="col-12">
    <app-server-response [response]="serverResponse"></app-server-response>
  </div>
</div>
<div class="row">
  <div *ngIf="case" class="col-4">
    <app-case-quick-client-editor [case]="case" (caseClientsUpdated)="updateCaseClients($event)">
    </app-case-quick-client-editor>
  </div>
  <div *ngIf="case && caseCreditor" class="col-4">
    <app-case-creditor-overview
      [case]="case"
      [caseCreditor]="caseCreditor"
      (caseClientsUpdated)="updateCaseClients($event)"
      (settlementBalanceChanged)="onSettlementBalanceChanged($event)">
    </app-case-creditor-overview>
  </div>
  <div class="col-4" *ngIf="case && caseCreditor && settlementBalance >= 0">
    <app-case-creditor-status-editor [case]="case" (caseClientsUpdated)="updateCaseClients($event)" [caseCreditor]="caseCreditor" [settlementBalance]="settlementBalance"></app-case-creditor-status-editor>
  </div>
</div>

<div class="row mt-4">
  <div class="col-12" *ngIf="case && caseCreditor">
    <app-case-creditor-relation-list [case]="case" [caseCreditor]="caseCreditor"></app-case-creditor-relation-list>
  </div>
</div>
